import { render, staticRenderFns } from "./orderWeiBao.vue?vue&type=template&id=2de6c45d&scoped=true&"
import script from "./orderWeiBao.vue?vue&type=script&lang=js&"
export * from "./orderWeiBao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de6c45d",
  null
  
)

export default component.exports